"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.join.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _color = _interopRequireDefault(require("color"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _nav = _interopRequireDefault(require("../nav"));

var _getFontDefaultSetting = _interopRequireDefault(require("../utils/getFontDefaultSetting"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/menu.less");

var styles = {
  "root": "meepshop-meep-ui__newMenu-menu__root",
  "logo-left": "meepshop-meep-ui__newMenu-menu__logo-left",
  "logo-right": "meepshop-meep-ui__newMenu-menu__logo-right",
  "alignment-left": "meepshop-meep-ui__newMenu-menu__alignment-left",
  "alignment-center": "meepshop-meep-ui__newMenu-menu__alignment-center",
  "alignment-right": "meepshop-meep-ui__newMenu-menu__alignment-right",
  "alignment-separate": "meepshop-meep-ui__newMenu-menu__alignment-separate",
  "logo-top": "meepshop-meep-ui__newMenu-menu__logo-top"
};

var Menu = function Menu(_ref) {
  var _design$normal$backgr, _design$normal, _design$normal$color, _design$normal2, _design$normal$border, _design$normal3, _design$hover$backgro, _design$hover, _design$hover$color, _design$hover2, _design$hover$borderC, _design$hover3, _design$active$backgr, _design$active, _design$active$color, _design$active2, _design$active$border, _design$active3;

  var id = _ref.id,
      menu = _ref.menu;

  /** LOGO 位置, 圖示大小, 選單設計及所有的頁面按鈕 */
  var logoAlignment = menu.logoAlignment,
      iconSize = menu.iconSize,
      design = menu.design,
      pages = menu.pages;

  var _ref2 = design || {},
      font = _ref2.font;

  var menuColors = {
    color: design === null || design === void 0 ? void 0 : design.normal.color,
    background: design === null || design === void 0 ? void 0 : design.normal.background
  }; // 如果不顯示 logo 且選單為 separate 對齊，需調整為靠右對齊

  var adjustedAlignment = !(design !== null && design !== void 0 && design.showLogo) && (design === null || design === void 0 ? void 0 : design.alignment) === 'separate' ? 'right' : design === null || design === void 0 ? void 0 : design.alignment;
  var classNames = [styles.root, styles["logo-".concat((logoAlignment === null || logoAlignment === void 0 ? void 0 : logoAlignment.toLowerCase()) || 'left')], // LEFT, RIGHT, TOP, null
  styles["alignment-".concat(adjustedAlignment || 'right')] // left, center, right, separate (logoAlignment 為 TOP separate 會沒有效果)
  ];
  var menuSettings = (0, _react.useMemo)(function () {
    var _ref3 = design || {},
        pattern = _ref3.pattern,
        height = _ref3.height,
        opacity = _ref3.opacity,
        fontSize = _ref3.fontSize,
        submenuFontSize = _ref3.submenuFontSize,
        showSearchbar = _ref3.showSearchbar,
        alignment = _ref3.alignment,
        expandSubItem = _ref3.expandSubItem;

    return {
      iconSize: iconSize,
      pattern: pattern !== null && pattern !== void 0 ? pattern : 1,
      height: height || 60,
      fontSize: fontSize || 14,
      opacity: opacity || 1,
      showSearchbar: showSearchbar || false,
      alignment: alignment || 'right',
      expandSubItem: expandSubItem || false,
      submenuFontSize: submenuFontSize || 14
    };
  }, [design, iconSize]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: classNames.join(' '),
    style: {
      fill: (menuColors === null || menuColors === void 0 ? void 0 : menuColors.color) || 'var(--color-3)',
      color: (menuColors === null || menuColors === void 0 ? void 0 : menuColors.color) || 'var(--color-3)',
      // colors[1] = --color-2
      background: menuColors !== null && menuColors !== void 0 && menuColors.background ? (0, _color["default"])(menuColors.background).alpha(menuSettings.opacity) : "rgba(var(--color-rgb-2), ".concat(menuSettings.opacity, ")"),
      fontSize: "".concat(menuSettings.fontSize, "px"),
      fontFamily: (0, _getFontDefaultSetting["default"])(font),
      '--bg': (_design$normal$backgr = design === null || design === void 0 ? void 0 : (_design$normal = design.normal) === null || _design$normal === void 0 ? void 0 : _design$normal.background) !== null && _design$normal$backgr !== void 0 ? _design$normal$backgr : 'var(--color-2)',
      '--color': (_design$normal$color = design === null || design === void 0 ? void 0 : (_design$normal2 = design.normal) === null || _design$normal2 === void 0 ? void 0 : _design$normal2.color) !== null && _design$normal$color !== void 0 ? _design$normal$color : 'var(--color-3)',
      '--border-color': (_design$normal$border = design === null || design === void 0 ? void 0 : (_design$normal3 = design.normal) === null || _design$normal3 === void 0 ? void 0 : _design$normal3.borderColor) !== null && _design$normal$border !== void 0 ? _design$normal$border : 'var(--color-3)',
      '--hover-bg': (_design$hover$backgro = design === null || design === void 0 ? void 0 : (_design$hover = design.hover) === null || _design$hover === void 0 ? void 0 : _design$hover.background) !== null && _design$hover$backgro !== void 0 ? _design$hover$backgro : 'var(--color-2)',
      '--hover-color': (_design$hover$color = design === null || design === void 0 ? void 0 : (_design$hover2 = design.hover) === null || _design$hover2 === void 0 ? void 0 : _design$hover2.color) !== null && _design$hover$color !== void 0 ? _design$hover$color : 'var(--color-3)',
      '--hover-border-color': (_design$hover$borderC = design === null || design === void 0 ? void 0 : (_design$hover3 = design.hover) === null || _design$hover3 === void 0 ? void 0 : _design$hover3.borderColor) !== null && _design$hover$borderC !== void 0 ? _design$hover$borderC : 'var(--color-3)',
      '--selected-bg': (_design$active$backgr = design === null || design === void 0 ? void 0 : (_design$active = design.active) === null || _design$active === void 0 ? void 0 : _design$active.background) !== null && _design$active$backgr !== void 0 ? _design$active$backgr : 'var(--color-2)',
      '--selected-color': (_design$active$color = design === null || design === void 0 ? void 0 : (_design$active2 = design.active) === null || _design$active2 === void 0 ? void 0 : _design$active2.color) !== null && _design$active$color !== void 0 ? _design$active$color : 'var(--color-3)',
      '--selected-border-color': (_design$active$border = design === null || design === void 0 ? void 0 : (_design$active3 = design.active) === null || _design$active3 === void 0 ? void 0 : _design$active3.borderColor) !== null && _design$active$border !== void 0 ? _design$active$border : 'var(--color-3)'
    }
  }, !!(design !== null && design !== void 0 && design.showLogo) && /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    height: design === null || design === void 0 ? void 0 : design.height
  }), /*#__PURE__*/_react["default"].createElement(_nav["default"], {
    pages: pages,
    menuSettings: menuSettings
  }));
};

Menu.propTypes = {
  menu: _propTypes["default"].shape({
    logoAlignment: _propTypes["default"].oneOf(['LEFT', 'RIGHT', 'CENTER'])
  }).isRequired
};
var _default = Menu;
exports["default"] = _default;